// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1LUmE","select":"Header_select__17sOl","clinic":"Header_clinic__2PVt-"};